<template>
  <div id="main-wrapper">
    <NavbarDark />

    <!-- Hero Section -->
    <section class="bg-primary position-relative">
      <div class="position-absolute start-0 top-0 w-25 h-15 bg-light rounded-end-pill opacity-25 mt-4"></div>
      <div class="position-absolute start-0 bottom-0 w-15 h-20 bg-light rounded-top-pill opacity-25 ms-4"></div>
      <div class="position-absolute end-0 top-0 w-15 h-25 bg-light rounded-bottom-pill opacity-25 me-4"></div>
      <div class="position-absolute end-0 bottom-0 w-25 h-15 bg-light rounded-start-pill opacity-25 mb-4"></div>
      <div class="ht-30"></div>
      <div class="container">
        <div class="row justify-content-center">
          <FormTwo />
        </div>
      </div>
      <div class="ht-30"></div>
    </section>
    <!-- Providers & Sidebar -->
    <section class="gray-simple">
      <div :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'" class="container">
        <div class="row">
          <div class="col-lg-8 col-md-12">
            <!-- <p v-for="ad in filteredAds" :key="ad.id">
              provider_id: {{ ad.provider_id }} | link_type: {{ ad.link_type }}
            </p> -->
            <div class="row" v-if="filteredAds.length > 0" >
              <!-- <div class="col-lg-8 col-md-12"> -->
                <div class="slider-wrapper" dir="ltr">
                  <div
                    class="slider"
                    :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
                  >
                    <div
                      v-for="(ad, index) in filteredAds"
                      :key="index"
                      class="slide"
                    >
                      <router-link
                        v-if="ad.link_type === 'internal' && ad.provider_id"
                        :to="`/service-provider/show-details/${ad.provider_id}`"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="block"
                      >
                        <img :src="ad.image" :alt="'Ad ' + index" />
                      </router-link>

                      <a
                        v-else
                        :href="ad.link"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img :src="ad.image" :alt="'Ad ' + index" />
                      </a>
                    </div>

                  </div>
                </div>
              <!-- </div> -->
            </div>
            <div class="row">
              <div class="item-shorting-box">
              <div class="item-shorting clearfix">
                <div class="left-column pull-left">
                  <h4 class="m-0 fs-6">
                    {{ totalResults }} - {{ $t('Found Result') }}
                  </h4>
                </div>
              </div>
            </div>

            <div v-if="providers.length === 0">
              <p>{{ $t('There is no provider with these specifications yet.') }}</p>
            </div>

            <div class="row">
              <div
                v-for="(item, index) in providers"
                :key="index"
                class="col-md-3 mb-4"
              >
                <GridLayout2 :item="item" />
              </div>
              <div id="scroll-sentinel" class="text-center my-4">
                <span v-if="loading">{{ $t('Downloading..') }}</span>
              </div>
            </div>
            </div>
          </div>

          <!-- Sidebar -->
          <div class="col-lg-4 col-md-12 col-sm-12">
            <div class="details-sidebar">
              <div class="sidebar-widgets">
                <h4>{{ $t('Featured service providers') }}</h4>
                <div class="sidebar_featured_property">
                  <div class="vertical-marquee-container">
                    <div class="vertical-marquee-content" :style="{ animationDuration: marqueeDuration }">
                      <div
                        v-for="(provider, index) in featuredProviders"
                        :key="index"
                        class="vertical-marquee-item flex items-center gap-2"
                      >
                        <UserIcon class="w-5 h-5 text-primary" />
                        <router-link
                          :to="`/service-provider/show-details/${provider.id}`"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {{ provider.name }} &nbsp;{{ provider.category.name }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Sidebar Ads -->
              <br />
              <div class="sides-widget">
                <div
                  v-for="(ad, index) in filteredAdSide"
                  :key="index"
                  @click="openAd(ad.link)"
                  class="ad-item"
                >
                  <img :src="ad.image" :alt="'Ad ' + index" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <FooterTop :bg="'theme-bg'" />
    <FooterDark />
    <ScrollToTop />
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue';
import { useRoute } from 'vue-router';
import axios from 'axios';
import NavbarDark from '@/components/navbar/navbar-dark.vue';
import FooterDark from '@/components/footer/footer-dark.vue';
import FooterTop from '@/components/footer/footer-top.vue';
import ScrollToTop from '@/components/scroll-to-top.vue';
import FormTwo from '@/components/form/form-two.vue';
import GridLayout2 from '@/components/property/grid-layout2.vue';
import { UserIcon } from '@heroicons/vue/24/outline'
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
const route = useRoute();
const providers = ref([]);
const totalResults = ref(0);
const loading = ref(false);
const observer = ref(null);
const perPage = ref(0);
const from = ref(0);
const to = ref(0);
const currentPage = ref(1);
const totalPages = ref(1);

const fetchProviders = async () => {
  if (loading.value || currentPage.value > totalPages.value) return;
  try {
    const response = await axios.get('/users/list-service-provider', {
      params: {
        category_id: route.query.category_id || null,
        state_id: route.query.state_id || null,
        city_id: route.query.city_id || null,
        subcategory_id: route.query.subcategory_id || null,
        name: route.query.name || null,
        page: currentPage.value
      },
      headers: {
      'locale': locale.value
      }
    });
    if (currentPage.value === 1) {
        providers.value = response.data.service_providers;
    } else {
        providers.value.push(...response.data.service_providers);
    }
        totalResults.value = response.data.pagination.total;
        perPage.value = response.data.per_page;
        from.value = (currentPage.value - 1) * perPage.value + 1;
        to.value = Math.min(from.value + providers.value.length - 1, totalResults.value);
        totalPages.value = response.data.last_page;
        currentPage.value++;
        console.log("totalResults",totalResults.value);
        
  } catch (error) {
    console.error("Error fetching providers:", error);
  } finally {
    loading.value = false;
  }
};

watch(
  () => route.query,
  () => {
    providers.value = [];
    currentPage.value = 1;
    totalPages.value = 1;
    totalResults.value = 0;
    from.value = 0;
    to.value = 0;

    fetchProviders();
  },
  { deep: true }
);
watch(locale, () => {
  currentPage.value = 1;
  providers.value = [];
  currentIndex.value = 0; 
  fetchProviders();
  fetchAds();
  fetchFeaturedProviders();
});
const ads = ref([]);
const currentIndex = ref(0);
const interval = ref(null);

const fetchAds = async () => {
  loading.value = true;
  try {
    const { data } = await axios.get('/get-ads', {
      params: {
        category_id: route.query.category_id || null,
        state_id: route.query.state_id || null,
        city_id: route.query.city_id || null,
        type: "web",
      },
    });
    ads.value = data.ads || [];
    console.log("Fetched Ads:", data.ads);
  } catch (error) {
    console.error("Error fetching ads:", error);
  } finally {
    loading.value = false;
  }
};

watch(() => route.query, fetchAds, { deep: true });

const filteredAds = computed(() => ads.value.filter(ad => ad.place === 'top_ad'));
const filteredAdSide = computed(() => ads.value.filter(ad => ad.place === 'sidebar_ad'));

const openAd = (url) => {
  window.open(url, '_blank');
};

const startSlider = () => {
  interval.value = setInterval(() => {
    if (filteredAds.value.length > 0) {
      currentIndex.value = (currentIndex.value + 1) % filteredAds.value.length;
    }
  }, 3000);
};

const stopSlider = () => {
  clearInterval(interval.value);
};

const featuredProviders = ref([]);

const fetchFeaturedProviders = async () => {
  try {
    const res = await axios.get("/users/list-service-provider-without-paginate?featured=featured",{
      headers:{
        'locale':locale.value
      }
    });
    featuredProviders.value = res.data.service_providers;
  } catch (error) {
    console.error('Error fetching featured providers:', error);
  }
};

const setupObserver = () => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting && !loading.value) {
      fetchProviders();
    }
  });

  const sentinel = document.getElementById('scroll-sentinel');
  if (sentinel) observer.value.observe(sentinel);
};
const marqueeDuration = computed(() => {
  const count = featuredProviders.value.length;
  if (count === 0) return "30s";
  return `${count * 5}s`; 
});
onMounted(() => {
  fetchProviders();
  fetchAds();
  fetchFeaturedProviders();
  setupObserver();
  startSlider();
});

onUnmounted(() => {
  stopSlider();
  if (observer.value) observer.value.disconnect();
});
</script>

<style scoped>
.slider-wrapper {
  width: 100%;
  height: 180px;
  margin: 7px auto;
  overflow: hidden;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.slider {
  display: flex;
  transition: transform 0.5s ease-in-out;
}

.slide {
  flex: 0 0 100%;
  cursor: pointer;
}

.slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.vertical-marquee-container {
  height: 150px;
  overflow: hidden;
  background: #fff;
  border-radius: 8px;
  position: relative;
}

.vertical-marquee-content {
  display: flex;
  flex-direction: column;
  animation: scroll-up linear infinite;
}

.vertical-marquee-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px;
  font-weight: bold;
  font-size: 1em;
  color: #333;
}

@keyframes scroll-up {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-50%);
  }
}
</style>
